import { Link, Navigate, NavLink, Outlet } from "react-router-dom";
import { ClipboardList, DollarSign, ExternalLink, Image, Loader2, LogOut, Palette, Settings, Shirt } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Orders & Quotes", icon: ClipboardList, end: true, id: "submissions" },
  { to: "/admin/products", label: "Design Products", icon: Palette, id: "products" },
  { to: "/admin/services", label: "Services", icon: Shirt, id: "services" },
  { to: "/admin/pricing", label: "Pricing", icon: DollarSign, id: "pricing" },
  { to: "/admin/gallery", label: "Gallery", icon: Image, id: "gallery" },
  { to: "/admin/settings", label: "Site Settings", icon: Settings, id: "settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center bg-[#090A0F]"><Loader2 className="h-8 w-8 animate-spin text-[#E5202A]" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return (
    <div className="min-h-screen bg-[#090A0F] lg:flex">
      <aside className="border-b border-white/10 bg-black lg:fixed lg:inset-y-0 lg:w-60 lg:border-b-0 lg:border-r">
        <div className="flex items-center gap-3 px-5 py-4">
          <img src="/assets/logo-anim.png" alt="" className="h-12" />
          <div><p className="font-display text-lg font-black uppercase leading-none">ASAP & Co.</p><p className="text-xs text-slate-500">Admin</p></div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col lg:pb-0">
          {LINKS.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex shrink-0 items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold transition-colors ${isActive ? "bg-[#E5202A] text-white" : "text-slate-300 hover:bg-white/5"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden space-y-1 px-3 pt-6 lg:block">
          <Link to="/" target="_blank" className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate-400 hover:bg-white/5" data-testid="admin-view-site-link"><ExternalLink className="h-4 w-4" />View site</Link>
          <button onClick={logout} className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate-400 hover:bg-white/5" data-testid="admin-logout-button"><LogOut className="h-4 w-4" />Log out</button>
          <p className="truncate px-3 pt-2 text-xs text-slate-600">{user.email}</p>
        </div>
      </aside>
      <main className="flex-1 p-4 sm:p-8 lg:ml-60">
        <button onClick={logout} className="mb-4 text-sm text-slate-400 lg:hidden" data-testid="admin-logout-button-mobile">Log out</button>
        <Outlet />
      </main>
    </div>
  );
}
